module.exports = __webpack_public_path__ + "static/logo-dark-19297911088bc5c181aa06328b1ffd8e.png";